import React, { useEffect, useState } from 'react';
import styled, { keyframes } from "styled-components";
import { newTag } from "../api/tag";
import { TagIF } from '../types';

/* Search.tsx는 검색창을 보여주고 검색어를 입력받는 컴포넌트 */

const BtnHoverAnimation = (before: string, after: string) => keyframes`
  0% {
    background-color: ${before};
  }  

  100% {
    background-color: ${after};
  }
`;
interface SearchProps {
    searchedTerm: string,
    onSearchedTerm: React.Dispatch<React.SetStateAction<string>>,
    tags: TagIF[],
    onTags: React.Dispatch<React.SetStateAction<TagIF[]>>
}

const Body = styled.div`
  display: fixed;
  padding: 10px;

  height: 30px;
  width: 100%;

  align-items: center;
`;

const SearchBox = styled.input.attrs({required: true, placeholder: "🔍"})`
  width: 100%;
  max-width: 700px;
  height: 2.5rem;
  padding: 0 1rem 0 1rem; /* 아이콘 자리를 위해 왼쪽 여백 */
  border-radius: 2rem;
  color: ${props => props.theme.CONTENT.TITLE_COLOR};
  border: 1px solid ${props => props.theme.SEARCH.BORDER};
  background: ${props => props.theme.SEARCH.BACKGROUND};
  font-size: 0.95rem;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 4px ${props => props.theme.SEARCH.SHADOW};

  &:focus {
    outline: none;
    width: 110%; /* 포커스 시 살짝 길어지는 효과 */
    border-color: ${props => props.theme.SEARCH.FOCUS.BORDER};
    box-shadow: 0 0 0 2px ${props => props.theme.SEARCH.FOCUS.SHADOW};
  }

  &::placeholder {
        color: ${props => props.theme.CONTENT.TITLE_COLOR};
    }
`;

const Btn = styled.button`
    width: 4rem;
    height: 2.4rem;

    padding: 2rem auto;
    margin-left: 3rem;

    border-radius: 0.5rem;
    border: 1px solid ${props => props.theme.BTN_ADD_DELETE.BORDER};
    color: ${props => props.theme.BTN_ADD_DELETE.FONT_COLOR};

    letter-spacing: -1px;
    font-weight: 600;

    &:hover {
        animation: ${props => BtnHoverAnimation(props.theme.BTN_ADD_DELETE.HOVER.BACKGROUND.FIRST, 
            props.theme.BTN_ADD_DELETE.HOVER.BACKGROUND.LAST)} 0.3s;
        background-color: ${props => props.theme.BTN_ADD_DELETE.HOVER.BACKGROUND.LAST};
        box-shadow: inset 0 6px 6px ${props => props.theme.BTN_ADD_DELETE.HOVER.SHADOW};
    }

    &:not(:hover) {
        animation: ${props => BtnHoverAnimation(props.theme.BTN_ADD_DELETE.HOVER.BACKGROUND.LAST, 
            props.theme.BTN_ADD_DELETE.HOVER.BACKGROUND.FIRST)} 0.3s;
        background-color: ${props => props.theme.BTN_ADD_DELETE.HOVER.BACKGROUND.FIRST};
    }
`;

function TagSearch({searchedTerm, onSearchedTerm, tags, onTags}: SearchProps) {
    const [searchTerm, setSearchTerm] = useState(searchedTerm);

    useEffect(() => {
        onSearchedTerm(searchTerm); // props는 읽기 전용이므로 반드시 이렇게 콜백 함수를 통해 부모 컴포넌트로 전달해야 함
    }, [searchTerm]);

    const onChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    // 이미 존재하는 태그인가? (대소문자 구분 X)
    const isExistedTag = (searchTerm: string) => {
        if (tags.some(t => t.name.toUpperCase() === searchTerm.toUpperCase()))
            return true;
        return false;
    }

    // 태그 검색 창에 새로 추가할 태그명 입력한 뒤 Add 버튼 누를 경우 새 태그 추가하게끔 함
    const createTag = async () => {
        try {
            if(searchTerm.trim() === "")
                alert("아무것도 입력되지 않았습니다. 다시 입력해주세요.");

            else {
                if (!isExistedTag(searchTerm)){
                // id: 현재 날짜(ms단위), name: 검색어
                    const id = Date.now();
                    
                    const newtag = await newTag(id, searchTerm);
                    onTags([...tags, newtag]);
                    
                } else {
                    alert("이미 존재하는 Tag 입니다! 다시 시도해주세요.");
                }
            }
        } catch (error) {
            console.error("새 태그 생성 실패: ", error);
            alert("새 태그 생성에 실패했습니다. 다시 시도해주세요.");
        }
    }

    return <Body>
        <SearchBox onChange={onChange}/>
        <Btn onClick={createTag}>Add</Btn>
    </Body>;
}

export default TagSearch;